module.exports = __webpack_public_path__ + "img/Infografia2.7ab12f93.png";